import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface EmploymentTypesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<EmploymentTypesServiceData>(db, 'employmentTypesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
